export default "__VITE_ASSET__DgYtcoIo__"